const lang = document.querySelector('html').lang,
    fallbackLang = document.querySelector('html').dataset.langFallback;

App.prototype.translateAttribute = function (attribute) {

    try{

        if (typeof attribute[lang] !== 'undefined' && attribute[lang] !== null){

            return attribute[lang];

        }

        if (typeof attribute[fallbackLang] !== 'undefined' && attribute[fallbackLang] !== null){

            return attribute[fallbackLang];

        }

        for (const attributeKey in attribute) {

            if ([lang, fallbackLang].indexOf(attributeKey) === -1 && attribute[attributeKey] !== null){

                return attribute[attributeKey];

            }

        }

        return null;

    }catch (e) {

        return attribute;

    }
};
